import useSystem from "./useSystem";

export default function useCropYear() {
  const data = useSystem();
  return data ? data.cropYear : 2020;
}
